const Dots = () => {
    return (
        <div>
            <h2 className={'content-block'}>Точки учета</h2>
        </div>
    )
}

export default Dots